
import { ref, onMounted, reactive, defineComponent } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import Form from './Form.vue'

export default defineComponent({
  components: {
    DataTable,
    Form
  },
  setup() {
    const tabelParams = reactive({
      endpoint: '/talent/v1/buildings',
      headerTitle: 'Master Gedung',
      buttonTitle: '',
      editTitle: 'Edit',
      deleteTitle: 'Hapus',
      confirmDialogDelete: {
        title: 'Hapus Gedung?',
        subTitle: 'Data Gedung tersebut akan dihapus dalam sistem. Yakin hapus Gedung?',
        btnSubmitTitle: 'Hapus Gedung',
      },
      columnsTable: [
        {
          field: 'name',
          headerName: 'Nama Gedung',
          searchable: true,
          fieldSearch: 'Name',
          isRender: false
        },
        {
          field: 'code',
          headerName: 'Kode',
          searchable: true,
          fieldSearch: null,
          isRender: false
        },
        {
          field: 'address',
          headerName: 'Alamat',
          searchable: true,
          fieldSearch: null,
          isRender: false
        },
      ]
    })

    const onDeleteFailedMessage = ref({
      summary: 'Gagal menghapus Data Gedung',
      detail: 'Data Gedung masih terhubung dengan Data Karyawan. Silahkan periksa Master Karyawan terlebih dahulu.'
    })
    // const slotBank = 'MsBank.Name'
    // const slotChannelBank = 'MsChannelBanks.OaAccount'
    // const getBankChannelId = (data: any) => {
    //   console.log('data', data)
    // }
    return {
      tabelParams,
      onDeleteFailedMessage
    }
  }
})
